import React from 'react';
import { HotelFacts, HotelFactsMobile } from '@lt/components';
import classnames from 'classnames';

import getFactsItemData from '../../utils/getFactsItemData';
import FactsIcon from './FactsIcon';

import styles from './facts.module.css';
import { HOTEL_FACTS_ORDER } from '../../store/hotel';

type FactsProps = {
  isMobile: boolean;
  facts: Record<string, string | number | boolean | object | undefined>;
};

const Facts = ({ isMobile = false, facts }: FactsProps): JSX.Element | null => {
  const factsData = HOTEL_FACTS_ORDER.map((type) => {
    const item = getFactsItemData(type, facts[type]);
    return item
      ? {
          ...item,
          icon: <FactsIcon type={item.iconName} isMobile={isMobile} />,
        }
      : null;
    // Костылек с type predicate, потому что ts не может сам определить тип после filter
  }).filter((el): el is Exclude<typeof el, null> => el !== null);

  const Component = isMobile ? HotelFactsMobile : HotelFacts;

  return (
    <Component
      facts={factsData}
      className={classnames({
        [styles.hotelFactsMobile]: isMobile,
      })}
    />
  );
};

export default Facts;
